<script setup lang="ts">
import AppMenu from './AppMenu.vue';
import VersionDisplay from 'src/components/VersionDisplay.vue';
import { useLayout } from 'src/composables/useLayout';

const { resetMenu, isSidebarActive } = useLayout();
</script>

<template>
    <div class="layout-sidebar">
        <div class="layout-sidebar-header">
            <button
                v-if="isSidebarActive"
                class="layout-sidebar-close p-link"
                @click="resetMenu"
            >
                <i class="pi pi-times"></i>
            </button>
        </div>
        <app-menu />
        <div class="layout-sidebar-footer">
            <VersionDisplay />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.layout-sidebar-header {
    display: flex;
    justify-content: flex-end;
    padding: 0;
    min-height: 0;
}

.layout-sidebar-close {
    display: none;
    border: none;
    background: transparent;
    color: var(--text-color);
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    transition: background-color 0.2s;

    &:hover {
        background-color: var(--surface-hover);
    }

    i {
        font-size: 1.25rem;
    }
}

.layout-sidebar-footer {
    margin-top: auto;
    padding: 1rem 0.5rem 0.5rem 0.5rem;
    border-top: 1px solid var(--surface-border);
}

@media screen and (max-width: 991px) {
    .layout-sidebar-header {
        padding: 0.5rem;
    }

    .layout-sidebar-close {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
